import Swiper from "swiper";
import { Autoplay, Navigation, Pagination, Thumbs } from "swiper/modules";

import lightGallery from "lightgallery";
import lgVideo from "lightgallery/plugins/video";

import { openGalleryLg } from "./utils/func-open-gallery";
import { addSlideClass } from "./utils/func-add-slide-class";

const setLightGallery = (wrapper, selector) => {
	return lightGallery(wrapper, {
		plugins: [lgVideo],
		licenseKey: "6741E8B5-B108-4C2A-BAB5-8C25D1E8ECA2",
		selector: selector,
		speed: 500,
	});
};

class Product {
	constructor() {
		this.specDom = document.querySelector(".product__spec-slide");
		this.fullSlide();
		this.thumbnailSlide();
		this.keywordGallery();
		this.keywordSlide();
		this.specGallery();
		this.openSpecDetail();
	}

	fullSlide() {
		const fullSlides = document.querySelectorAll(".product__full-slide");
		fullSlides.forEach((element) => {
			addSlideClass(element);

			new Swiper(element, {
				modules: [Pagination, Autoplay],
				speed: 400,
				spaceBetween: 0,
				loop: true,
				autoplay: {
					delay: 5000,
				},
			});
		});
	}

	keywordSlide() {
		const wrapper = document.querySelector(".product__keyword-wrapper--slide");
		if (wrapper) {
			addSlideClass(wrapper);
			const thumbSwiper = new Swiper(wrapper, {
				slidesPerView: "auto",
				spaceBetween: 9,
				breakpoints: {
					640: {
						spaceBetween: 30,
					},
				},
			});
		}
	}

	thumbnailSlide() {
		const thumbnailSlides = document.querySelectorAll(".thumbnail-slide");
		thumbnailSlides.forEach((element) => {
			const mainWrapper = element.querySelector(".thumbnail-slide__main-slide");
			const thumbWrapper = element.querySelector(".thumbnail-slide__thumb-slide");

			addSlideClass(mainWrapper);
			if (thumbWrapper.children.length <= 0) {
				thumbWrapper.innerHTML = mainWrapper.innerHTML;
			}
			addSlideClass(thumbWrapper);

			const thumbSwiper = new Swiper(thumbWrapper, {
				slidesPerView: "auto",
				slideToClickedSlide: true,
				spaceBetween: 9,
				breakpoints: {
					640: {
						spaceBetween: 30,
					},
				},
			});
			const mainSwiper = new Swiper(mainWrapper, {
				modules: [Thumbs, Navigation],
				speed: 400,
				spaceBetween: 0,
				loop: true,
				navigation: {
					nextEl: ".thumbnail-slide__navigation--next",
					prevEl: ".thumbnail-slide__navigation--prev",
				},
				thumbs: {
					swiper: thumbSwiper,
				},
			});

			// video시 data-video 삽입하는 코드
			const mainSlide = mainWrapper.querySelectorAll(".swiper-slide");
			mainSlide.forEach((e) => {
				if (e.classList.contains("wp-block-video")) {
					const item = e.querySelector("video");
					const data = {
						source: [
							{
								src: item.src,
								type: "video/mp4",
							},
						],
						attributes: { preload: false, controls: true },
					};
					const json = JSON.stringify(data);
					item.dataset.lgSize = "1280-720";
					item.dataset.video = json;
					item.dataset.poster = item.poster;
				}
			});

			// lightGallery 생성 코드
			const dynamicGallery = setLightGallery(mainWrapper, "figure > *");
			openGalleryLg(element, dynamicGallery);
		});
	}

	keywordGallery() {
		this.keywordWrappers = document.querySelectorAll(".product__keyword-container");
		this.keywordWrappers.forEach((wrapper) => {
			const dynamicGallery = setLightGallery(wrapper, "img");
			openGalleryLg(wrapper, dynamicGallery);
		});
	}

	specGallery() {
		addSlideClass(this.specDom);
		this.specSwiper = new Swiper(this.specDom, {
			modules: [Autoplay],
			speed: 400,
			spaceBetween: 0,
			loop: true,
			autoplay: {
				delay: 3000,
			},
			navigation: {
				nextEl: ".thumbnail-slide__navigation--next",
				prevEl: ".thumbnail-slide__navigation--prev",
			},
		});
		this.specDynamicGallery = setLightGallery(this.specDom, "img");
		openGalleryLg(this.specDom, this.specDynamicGallery);
	}

	openSpecDetail() {
		const detail = document.querySelector(".product__spec-row--02");
		document.addEventListener("click", (e) => {
			if (e.target.classList.contains("open-spec")) {
				detail.classList.toggle("product__spec-row--02--active");
			}
		});
	}
}

export default Product;
